import $ from 'jquery';

const initTableStyle = () => {
    const $tables = $('.s-text-block-content table');
    if ($tables.length === 0) return;

    $tables.each(function () {
        const $table = $(this);
        if ($table.closest('.table-wrapper').length === 0) {
            $table.wrap('<div class="table-wrapper"></div>');
        }
    });
};

const moveFeesID = $el => {
    const feesID = $el.attr('id');
    $el.attr('id', `${feesID}-fees`);
    $el.prev().attr('id', feesID);
};

const initAsFeesIntro = () => {
    const $feeses = $('.s-fees');

    if ($feeses.length === 0) return;

    $feeses.each(function () {
        const $fees = $(this);
        const $feesPrev = $fees.prev();

        if ($feesPrev.hasClass('s-text-block')) {
            $feesPrev.addClass('as-fees-intro');
            moveFeesID($fees);
        }
    });
};

$(() => {
    initTableStyle();
    initAsFeesIntro();
});
